<app-page-meta pageTitle="finzy - Investor Passbook"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
    <div class="row">
        <app-investormenu></app-investormenu>

        <div class="col-xs-12 col-md-10 col-lg-11 main-content">
            <div class="row">
                <p class="finzy-passbook-header col-md-12">Keep track of all your money through your passbook!</p>
            </div>

            <div class="row form-container">
                <div class="col-xs-12 col-sm-6">
                    <div class="row">
                        <div class="col-xs-12">
                            <p class="finzyp2" style="margin-bottom:10px;">Select Date Range</p>
                            <p>(Transactions only within the last 30 days can be viewed below)</p>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <mat-form-field class="datepicker-wrapper" (click)="fromPicker.open()">
                                <input matInput placeholder="From Date" name="start_date"
                                       (dateChange)="changeFromDate($event)"
                                       [matDatepicker]="fromPicker" [max]="maxDate" [min]="this.fromDate" disabled>
                                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                                <mat-datepicker #fromPicker disabled="false"></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <mat-form-field class="datepicker-wrapper" (click)="toPicker.open()">
                                <input matInput placeholder="To Date" name="last_date"
                                       (dateChange)="changeToDate($event)"
                                       [matDatepicker]="toPicker"
                                       [min]="passbookDateRangeFilter.fromDate" [max]="maxDate"
                                       (click)="toPicker.open()" disabled>
                                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                                <mat-datepicker #toPicker disabled="false"></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-3">
                    <p class="finzyp22">Transaction Type</p>
                    <br>
                    <div class="portfolio-selection-container">
                        <mat-form-field class="finzy-select-portfolio">
                            <mat-select placeholder="Select" name="transactionType"
                                        [(ngModel)]="transactionTypeFilter"
                                        style="width:90%">
                                <mat-option value="">All</mat-option>
                                <mat-option *ngFor="let type of transactionTypes" [value]="type" required>
                                    {{type}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-3 actions">
                    <div class="row">
                        <div class="col-xs-12 action-download ">
                            Download entire passbook as <br> 
                            <div *ngIf="shouldShowPdfOption" style="display: inline;">
                                <a (click)="downloadFile(getFileDownloadUrl('pdf'))" style="cursor:pointer;">PDF</a>
                                or
                            </div>
                            <a (click)="downloadFile(getFileDownloadUrl('csv'))" style="cursor:pointer;">Excel</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row finzy-row10 table-container">
                <mat-table #table
                    [dataSource]="dataSource | passbookDateRangeFilter: passbookDateRangeFilter | transactionTypeFilter: transactionTypeFilter"
                    matSort multiTemplateDataRows>

                    <ng-container matColumnDef="timestamp">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Date</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.timestamp | dateFormat}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="transactionType">
                        <mat-header-cell *matHeaderCellDef> Transaction Type</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.getDisplayableTransactionType()}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Amount</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            ₹ {{element.amount | round:2}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef> Description</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p><a routerLink="{{element.getRouterLink()}}"
                                  *ngIf="element.getRouterLink() != undefined "
                                  target="_blank">Loan Details</a>
                                {{element.getDescription()}} </p>
                            <p *ngIf="(!element.getRouterLink() && !element.getDescription())">--</p></mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="accordion_arrow">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-icon>{{element == expandedElement ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetail">
                        <mat-cell *matCellDef="let element">
                            <div class="accordion-element-detail" *ngIf="isMobile"
                                [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                <div style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;">
                                    <div style="padding: 8px;width: 50%;">
                                        Description
                                    </div>
                                    <div style="padding: 8px;width: 50%;">
                                        <a routerLink="{{element.getRouterLink()}}"
                                            *ngIf="element.getRouterLink() != undefined " target="_blank">Loan
                                            Details</a>
                                        {{element.getDescription()}}
                                        <span *ngIf="(!element.getRouterLink() && !element.getDescription())">--</span>
                                    </div>
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let element; columns: displayedColumns;" class="accordion-element-row"
                        [class.accordion-expanded-row]="expandedElement === element"
                        (click)="expandedElement = expandedElement === element ? null : element">
                    </mat-row>
                    <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="accordion-detail-row"></mat-row>

                </mat-table>

                <div class="row finzy-row10gray" *ngIf="dataSource.filteredData.length === 0">
                    <p class="greydivp1"><i style="font-size: 90px;color: #757575;"
                                            class="material-icons">info_outline</i>
                    </p>
                    <p class="greydivp">There are no transactions found for the filter combinations that you’ve
                        selected.</p>
                </div>

                <mat-paginator #paginator [pageSize]="10"
                               [pageSizeOptions]="[5, 10, 20, 50, 100]">
                </mat-paginator>
            </div>
        </div>

    </div>
</div>

<app-footer></app-footer>
